import { ref, computed } from 'vue'
import { defineStore, acceptHMRUpdate } from 'pinia'

export const useModalStore = defineStore('modal',  {

    state: () => ({
        _active_modal: null,
        _props: {},
        _anchor_el: null,
        _placement: null
    }),

    getters: {
        active_modal: (state) => state._active_modal,
        props: (state) => state._props,
        anchor_el: (state) => state._anchor_el,
        placement: (state) => state._placement
    },

    actions: {
       open (modal, props = {}, anchor_el = null, placement = "top-right") {
           this.close()
            this._active_modal = modal
            this._props = props
            this._anchor_el = anchor_el
            this._placement = placement
        },
        close (refresh = false) {
            this._active_modal = null
            this._props = {}
            this._anchor_el = null
            this._placement = null

            if (refresh) {
                window.location.reload()
            }
        }
    }
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useModalStore, import.meta.hot))
}
